import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.NODE_ENV === 'production'
			? process.env.VUE_APP_PATH + process.env.VUE_APP_VILLE
			: "",
	routes: [
		{
			path: '/',
			name: 'main',
			component: Main
		},
		{
			path: '/:slug',
			component: Main
		}
	]
})

router.afterEach((to, from) => {

	const path = to.fullPath;

	let _paq = window._paq || [];
    _paq.push(["setCustomUrl", router.options.base + path]);
    _paq.push(["trackPageView"]);

    if ("ga" in window && "function" === typeof window.ga) {
        ga('send', 'pageview', path);
	}

});

export default router;
